import styled from 'styled-components';
import { Checkbox as checkbox } from 'antd';

const Checkbox = styled(checkbox)``;

/** @component */
export default Checkbox;
